import { useEffect, useState } from "react";

import { getTariffOptions } from "services/tariffs/rest";
import { TariffOptionDto } from "services/tariffs/restModels";

/*
* Прайс статичен в пределах сессии, поэтому кешируем на уровне модуля и держим общий промис —
* иначе каждая открытая карточка заведения шла бы за ним заново.
* */
let cached: TariffOptionDto[] | null = null;
let inFlight: Promise<TariffOptionDto[] | null> | null = null;

const loadTariffOptions = (): Promise<TariffOptionDto[] | null> => {
    if (cached) return Promise.resolve(cached);

    if (!inFlight) {
        inFlight = getTariffOptions().then((options) => {
            inFlight = null;

            if (options) cached = options;

            return options;
        });
    }

    return inFlight;
};

export const useTariffOptions = () => {
    const [options, setOptions] = useState<TariffOptionDto[]>(cached || []);
    const [loading, setLoading] = useState(!cached);

    useEffect(() => {
        let ignore = false;

        loadTariffOptions().then((loaded) => {
            if (ignore) return;

            setOptions(loaded || []);
            setLoading(false);
        });

        return () => {
            ignore = true;
        };
    }, []);

    return { options, loading };
};
